import auth from "@/middleware/auth";
import admin from "@/middleware/admin";

export const agegroupRoutes = [
  {
    path: "/directories/agegroup",
    name: "AgegroupList",
    meta: { middleware: [auth, admin] },
    component: () =>
      import(/* webpackChunkName: "agegroup" */ "./components/List"),
  },
];
